module.exports = __webpack_public_path__ + "img/270e1077-85dd-4bb8-9024-0d7a538c1d65.2cf81886.png";